/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_X_LeftInputs */

const en_input_position_x_left = /** @type {(inputs: Input_Position_X_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left`)
};

const fr_input_position_x_left = /** @type {(inputs: Input_Position_X_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gauche`)
};

const de_input_position_x_left = /** @type {(inputs: Input_Position_X_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Links`)
};

const it_input_position_x_left = /** @type {(inputs: Input_Position_X_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinistra`)
};

const ru_input_position_x_left = /** @type {(inputs: Input_Position_X_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Левый`)
};

const es_input_position_x_left = /** @type {(inputs: Input_Position_X_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izquierda`)
};

const zh_cn2_input_position_x_left = /** @type {(inputs: Input_Position_X_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左边`)
};

const ja_input_position_x_left = /** @type {(inputs: Input_Position_X_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左`)
};

const hi_input_position_x_left = /** @type {(inputs: Input_Position_X_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाएं`)
};

const pt_pt2_input_position_x_left = /** @type {(inputs: Input_Position_X_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esquerda`)
};

/**
* | output |
* | --- |
* | "Left" |
*
* @param {Input_Position_X_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_x_left = /** @type {((inputs?: Input_Position_X_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_X_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_x_left(inputs)
	if (locale === "de") return de_input_position_x_left(inputs)
	if (locale === "it") return it_input_position_x_left(inputs)
	if (locale === "ru") return ru_input_position_x_left(inputs)
	if (locale === "es") return es_input_position_x_left(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_x_left(inputs)
	if (locale === "ja") return ja_input_position_x_left(inputs)
	if (locale === "hi") return hi_input_position_x_left(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_x_left(inputs)
	return en_input_position_x_left(inputs)
});